<template>
  <div class="time-selector-component">
    <div class="input-group">
      <span class="input-group-addon">
        <span class="fa fa-clock-o"></span>
      </span>
      <input class="form-control" type="text"
      v-model="timeLabel"
      @input="searchTimes()"
      @keydown.up.prevent="moveUpList()"
      @keydown.down.prevent="moveDownList()"
      @keydown.enter.prevent="selectTime($event)"
      @focus="showTimes()"/>
    </div>
    <div class="time-selector" v-if="selectingTime" v-el:times>
      <template v-for="(key, time) in availableTimes">
        <div class="time-selector-item"
        :class="{ 'active': key === selectedIndex }"
        @hover="changeIndex(key)"
        @mousedown="clickTime(key, $event)">
          <template v-if="time === '12:00pm'">
            Midday <span class="fa fa-sun-o pull-right"></span>
          </template>
          <template v-if="time === '12:00am'">
            Midnight <span class="fa fa-moon-o pull-right"></span>
          </template>
          <template v-if="time.indexOf('12:00') < 0">
            {{ time }}
            <span :class="{
              'fa-moon-o': !isDaylight(time),
              'fa-sun-o': isDaylight(time)
            }"
            class="fa pull-right"></span>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// use to close time picker
function handleOffClick (e) {
  let clickedInside = false
  let parent = e.target.parentNode
  while (parent) {
    if (parent.className === 'time-selector-component' &&
    (e.target.className === 'form-control' ||
    e.target.className === 'time-selector') &&
    this.$els.times && this.$els.times.parentNode.isSameNode(parent)) {
      parent = false
      clickedInside = true
    } else {
      parent = parent.parentNode
    }
  }
  if (!clickedInside) this.closeTimes()
}
export default {
  name: 'TimeInput',
  data () {
    return {
      selectingTime: false,
      times: [],
      availableTimes: [],
      searching: false,
      timeLabel: moment().format('h:mma'),
      selectedTime: moment(),
      selectedIndex: 0,
      offClick: function () {}
    }
  },
  methods: {
    showTimes () {
      for (let i = 0; i < this.availableTimes.length; i++) {
        if (this.availableTimes[i] === this.timeLabel) {
          this.selectedIndex = i
        }
      }
      this.selectingTime = true
      this.$nextTick(function () {
        let height = this.$els.times.children[this.selectedIndex].clientHeight
        this.$els.times.scrollTop = height * this.selectedIndex
        this.offClick = handleOffClick.bind(this)
        window.addEventListener('mousedown', this.offClick, false)
      })
    },
    searchTimes () {
      if (!this.searching) {
        this.searching = setTimeout(() => {
          this.availableTimes = this.times.filter((el) => {
            if (el.indexOf(this.timeLabel) >= 0) return true
            if (el.indexOf('12:00pm') >= 0) {
              if ('midday'.indexOf(this.timeLabel.toLowerCase()) >= 0) {
                return true
              }
            }
            if (el.indexOf('12:00am') >= 0) {
              if ('midnight'.indexOf(this.timeLabel.toLowerCase()) >= 0) {
                return true
              }
            }
          })
          this.selectedIndex = 0
          clearTimeout(this.searching)
          this.searching = false
        }, '500')
      }
    },
    selectTime ($event) {
      let time = this.availableTimes[this.selectedIndex]
      this.closeTimes()
      this.selectedTime = moment(time, 'h:mma')
      this.validateField()
      let target = $event.target || $event.srcElement
      target.blur()
      this.$dispatch('timeChanged', this.selectedTime.toDate())
      this.$nextTick(function () {
        this.timeLabel = time
      })
    },
    closeTimes () {
      window.removeEventListener('mousedown', this.offClick, false)
      this.selectingTime = false
    },
    validateField () {
      // this.selectedTime = moment(this.timeLabel, 'h:mma')
      if (this.timeLabel === '12:00pm') {
        this.timeLabel = 'Midday'
      }
      if (this.timeLabel === '12:00am') {
        this.timeLabel = 'Midnight'
      }
    },
    moveUpList () {
      if (this.selectedIndex > 0) {
        this.selectedIndex--
        this.changeIndex(this.selectedIndex)
      }
    },
    moveDownList () {
      if (this.selectedIndex < this.availableTimes.length - 1) {
        this.selectedIndex++
        this.changeIndex(this.selectedIndex)
      }
    },
    changeIndex (index) {
      this.selectedIndex = index
      this.timeLabel = this.availableTimes[index]
      this.selectedTime = moment(this.timeLabel, 'h:mma')
      this.$nextTick(function () {
        let height = this.$els.times.children[this.selectedIndex].clientHeight
        this.$els.times.scrollTop = height * this.selectedIndex
      })
    },
    clickTime (index, $event) {
      this.selectedIndex = index
      this.selectTime($event)
    },
    isDaylight (time) {
      let x = moment(time, 'h:mma')
      let y = x.clone().hours(6).minutes(0).seconds(0)
      let z = x.clone().hours(18).minutes(0).seconds(0)
      return x.isBetween(y, z, 'minutes')
    },
    setTime (date) {
      if (date) {
        this.selectedTime = moment(date)
        this.timeLabel = moment(date).format('h:mma')
        this.validateField()
        this.$dispatch('timeChanged', this.selectedTime.toDate())
      } else {
        this.selectedTime = null
        this.timeLabel = ''
      }
    },
    getTime () {
      return this.selectedTime ? this.selectedTime.toDate() : null
    },
    setMinDate (date) {
      let minDate = moment(date)
      let diff = minDate.minutes() % 15
      diff = 15 - diff
      minDate = minDate.add(diff, 'minutes')
      this.minDate = minDate
      if (minDate.isAfter(this.selectedTime)) {
        this.selectedTime = minDate
        this.timeLabel = minDate.format('h:mma')
      }
      if (this.timeLabel === '12:00pm') {
        this.timeLabel = 'Midday'
      }
      if (this.timeLabel === '12:00am') {
        this.timeLabel = 'Midnight'
      }
      this.refreshTimeList()
    },
    setMaxDate (date) {
      let maxDate = moment(date)
      let diff = maxDate.get('minutes', true) % 15
      diff = 15 - diff
      maxDate = maxDate.add(diff, 'minutes')
      this.maxDate = maxDate
      if (maxDate.isBefore(this.selectedTime)) {
        this.selectedTime = maxDate
        this.timeLabel = maxDate.format('h:mma')
      }
      if (this.timeLabel === '12:00pm') {
        this.timeLabel = 'Midday'
      }
      if (this.timeLabel === '12:00am') {
        this.timeLabel = 'Midnight'
      }
      this.refreshTimeList()
    },
    refreshTimeList () {
      let diff = this.selectedTime.minutes() % 15
      if (diff > 0) {
        this.selectedTime = this.selectedTime.clone().add(15 - diff, 'minutes')
      }
      let selectedTime = this.selectedTime
      let startOfDay = moment(this.$parent.field.minDate)
      let endOfDay = moment(this.$parent.field.maxDate)
      if (selectedTime.isAfter(startOfDay, 'day')) {
        startOfDay = selectedTime.clone().startOf('day')
      }
      endOfDay = startOfDay.clone().endOf('day')
      let minutes = startOfDay.minutes() % 15
      if (minutes > 0) {
        startOfDay.add(15 - minutes, 'minutes')
      }
      this.times = []
      while (startOfDay.isSameOrBefore(endOfDay)) {
        let label = startOfDay.format('h:mma')
        this.times.push(label)
        if (label === this.selectedTime.format('h:mma')) {
          this.timeLabel = label
          this.validateField()
        }
        startOfDay = startOfDay.clone().add(15, 'minutes')
      }
      this.availableTimes = this.times
      this.selectedIndex = 0
    }
  },
  events: {
    dateChanged (date) {
      let diff = Math.ceil(moment(date).diff(this.selectedTime, 'days', true))
      this.selectedTime = this.selectedTime.clone().add(diff, 'days')
      this.refreshTimeList()
    }
  },
  watch: {
    timeLabel (val) {
      let isValid = moment(val, 'h:mma', true).isValid() ||
      val === 'Midday' || val === 'Midnight'
      this.$dispatch('validated', isValid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TimeInput.vue?68238a02